import React, { createContext, useRef, useContext, ReactNode } from 'react';

// Define the type for the context
type SectionsRef = {
  [key: string]: HTMLElement | null;
};

// Create a context with an empty object as the default value
const ScrollContext = createContext<React.MutableRefObject<SectionsRef>>({ current: {} });

export const ScrollProvider = ({ children }: { children: ReactNode }) => {
  const sectionsRef = useRef<SectionsRef>({});
 
  return (
    <ScrollContext.Provider value={sectionsRef}>
      {children}
    </ScrollContext.Provider>
  );
};

export const useScrollContext = () => {
  return useContext(ScrollContext);
};
